import { render, staticRenderFns } from "./SectionBuilderEditor.vue?vue&type=template&id=16c32004&scoped=true&"
import script from "./SectionBuilderEditor.vue?vue&type=script&lang=js&"
export * from "./SectionBuilderEditor.vue?vue&type=script&lang=js&"
import style0 from "./SectionBuilderEditor.vue?vue&type=style&index=0&id=16c32004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c32004",
  null
  
)

export default component.exports